import type { Registry as Services } from '@ember/service';
import type { IntlContract } from 'shared-react/lumen';

/**
 * Translates ember-intl into shared-react's IntlContract, so mounted React
 * components format messages through lumen's translations without the
 * package needing a Lokalise project of its own.
 */
export default function createIntl(intl: Services['intl']): IntlContract {
  return {
    locale: intl.primaryLocale ?? 'en',
    formatMessage: ({ id }, values): string =>
      intl.t(String(id), values as Parameters<Services['intl']['t']>[1]),
  };
}
